import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Icon, AppBar, Toolbar, Typography } from '@material-ui/core';
import * as Actions from './../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const styles = theme => ({
    root: {}
});

class AssignmentGradeList extends Component {
    componentWillMount = () => {
        const instructor_id = this.props.auth.user.data.role_info.link_id;

        this.props.getAssignmentsNotGraded(instructor_id);
    }

    handleRowClick = (student_assignment_id) => {
        this.props.history.push(`/assignment/grader/${student_assignment_id}`);
    }

    render() {
        const { assignmentNotGradedList, classes } = this.props;

        if (assignmentNotGradedList.length === 0) {
            return (
                <React.Fragment>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography variant="h6" color="inherit">
                                Ungraded Assignments Widget
                            </Typography>
                        </Toolbar>

                    </AppBar>
                    <Typography className={'text-center p-8'}>No Assignments to Grade!</Typography>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" color="inherit">
                            Ungraded Assignments Widget
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Student Name</TableCell>
                            <TableCell>Course</TableCell>
                            <TableCell>Assignment</TableCell>
                            <TableCell>Grade</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {assignmentNotGradedList.map((student_assignment_info) => {
                            return (
                                <TableRow key={student_assignment_info.student_assignment_id}>
                                    <TableCell>{student_assignment_info.StudentName}</TableCell>
                                    <TableCell>{student_assignment_info.CourseName}</TableCell>
                                    <TableCell>{student_assignment_info.AssignmentName}</TableCell>
                                    <TableCell>
                                        <IconButton
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.handleRowClick(student_assignment_info.student_assignment_id);
                                            }}
                                        >
                                            <Icon>assignment</Icon>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAssignmentsNotGraded: Actions.getAssignmentsNotGraded
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth }) {
    return {
        assignmentNotGradedList: dashboardApp.widgets.assignmentNotGradedList,
        auth: auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssignmentGradeList)));




// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/AssignmentGradeList.js